import "./GalleryPage.css";

import React from "react";

import { useEffect, useState } from "react";

import { Link } from "react-router-dom";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import { GalleryModal } from "./GalleryModal";



export const GalleryPage = ({ galleryData, changeNavBar }) => {
  const [galleryImgsData, setGalleryImgsData] = useState(galleryData);
  useEffect(() => {
    let href = window.location.href;
    let subHref = href.split("/")[3];
    if (subHref === "gallery") {
      changeNavBar("isAboutUs", "rgba(41, 41, 41)", "white", "13rem", "row");
    }
  }, []);
  return (
    <div className="gallery-page-container">
      <div className="gallery-title-section">
        <h1 className="gallery-title">Галерия</h1>

        {/* <div className="gallery-title-nav">
          <Link className="gallery-title-nav-a" to="/">
            Начало
          </Link>

          <p className="gallery-title-nav-p">
            <ArrowForwardIosIcon sx={{ fontSize: "11px", mr: "0.3rem" }} />
            Галерия
          </p>
        </div> */}
      </div>
      <div className="gallery-page-content-container">
        <h1 className="gallery-page-content-h1">
          Футболисти използващи наши стоки
        </h1>
        <div className="gallery-page-imgs-container">
          {galleryImgsData.map((item) => {
            return <GalleryModal imgSrc={item.imgId} />;
          })}
        </div>
      </div>
    </div>
  );
};
